import { Divider as BaseDivider } from '@twistopayments/design-system/components/atoms/divider'

import * as styles from './divider.styles'

export const Divider = () => <BaseDivider css={styles.divider} />
